import { __module as colorString } from "../../_virtual/index.js";
import { c as colorName } from "../color-name/index.js";
import { s as simpleSwizzleExports } from "../simple-swizzle/index.js";
var colorNames = colorName, swizzle = simpleSwizzleExports, hasOwnProperty = Object.hasOwnProperty, reverseNames = /* @__PURE__ */ Object.create(null);
for (var name in colorNames)
  hasOwnProperty.call(colorNames, name) && (reverseNames[colorNames[name]] = name);
var cs = colorString.exports = {
  to: {},
  get: {}
};
cs.get = function(string) {
  var prefix = string.substring(0, 3).toLowerCase(), val, model;
  switch (prefix) {
    case "hsl":
      val = cs.get.hsl(string), model = "hsl";
      break;
    case "hwb":
      val = cs.get.hwb(string), model = "hwb";
      break;
    default:
      val = cs.get.rgb(string), model = "rgb";
      break;
  }
  return val ? { model, value: val } : null;
};
cs.get.rgb = function(string) {
  if (!string)
    return null;
  var abbr = /^#([a-f0-9]{3,4})$/i, hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i, rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, keyword = /^(\w+)$/, rgb = [0, 0, 0, 1], match, i, hexAlpha;
  if (match = string.match(hex)) {
    for (hexAlpha = match[2], match = match[1], i = 0; i < 3; i++) {
      var i2 = i * 2;
      rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
    }
    hexAlpha && (rgb[3] = parseInt(hexAlpha, 16) / 255);
  } else if (match = string.match(abbr)) {
    for (match = match[1], hexAlpha = match[3], i = 0; i < 3; i++)
      rgb[i] = parseInt(match[i] + match[i], 16);
    hexAlpha && (rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255);
  } else if (match = string.match(rgba)) {
    for (i = 0; i < 3; i++)
      rgb[i] = parseInt(match[i + 1], 0);
    match[4] && (match[5] ? rgb[3] = parseFloat(match[4]) * 0.01 : rgb[3] = parseFloat(match[4]));
  } else if (match = string.match(per)) {
    for (i = 0; i < 3; i++)
      rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
    match[4] && (match[5] ? rgb[3] = parseFloat(match[4]) * 0.01 : rgb[3] = parseFloat(match[4]));
  } else return (match = string.match(keyword)) ? match[1] === "transparent" ? [0, 0, 0, 0] : hasOwnProperty.call(colorNames, match[1]) ? (rgb = colorNames[match[1]], rgb[3] = 1, rgb) : null : null;
  for (i = 0; i < 3; i++)
    rgb[i] = clamp(rgb[i], 0, 255);
  return rgb[3] = clamp(rgb[3], 0, 1), rgb;
};
cs.get.hsl = function(string) {
  if (!string)
    return null;
  var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, match = string.match(hsl);
  if (match) {
    var alpha = parseFloat(match[4]), h = (parseFloat(match[1]) % 360 + 360) % 360, s = clamp(parseFloat(match[2]), 0, 100), l = clamp(parseFloat(match[3]), 0, 100), a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
    return [h, s, l, a];
  }
  return null;
};
cs.get.hwb = function(string) {
  if (!string)
    return null;
  var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, match = string.match(hwb);
  if (match) {
    var alpha = parseFloat(match[4]), h = (parseFloat(match[1]) % 360 + 360) % 360, w = clamp(parseFloat(match[2]), 0, 100), b = clamp(parseFloat(match[3]), 0, 100), a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
    return [h, w, b, a];
  }
  return null;
};
cs.to.hex = function() {
  var rgba = swizzle(arguments);
  return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : "");
};
cs.to.rgb = function() {
  var rgba = swizzle(arguments);
  return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
};
cs.to.rgb.percent = function() {
  var rgba = swizzle(arguments), r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
  return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r + "%, " + g + "%, " + b + "%)" : "rgba(" + r + "%, " + g + "%, " + b + "%, " + rgba[3] + ")";
};
cs.to.hsl = function() {
  var hsla = swizzle(arguments);
  return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
};
cs.to.hwb = function() {
  var hwba = swizzle(arguments), a = "";
  return hwba.length >= 4 && hwba[3] !== 1 && (a = ", " + hwba[3]), "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
};
cs.to.keyword = function(rgb) {
  return reverseNames[rgb.slice(0, 3)];
};
function clamp(num, min, max) {
  return Math.min(Math.max(min, num), max);
}
function hexDouble(num) {
  var str = Math.round(num).toString(16).toUpperCase();
  return str.length < 2 ? "0" + str : str;
}
var colorStringExports = colorString.exports;
export {
  colorStringExports as c
};
//# sourceMappingURL=index.js.map
